module.exports = __webpack_public_path__ + "img/packages/l8.2bf168.png";